import React, { useState } from 'react';
import './styles/Footer.css';

const Footer = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <p>Navriti Technologies &copy; All rights reserved</p>
          <button 
            className="message-icon-btn" 
            onClick={() => setShowPopup(!showPopup)}
            aria-label="Contact Support"
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" 
                fill="currentColor"
              />
              <path 
                d="M7 9H17V11H7V9ZM7 6H17V8H7V6ZM7 12H14V14H7V12Z" 
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </footer>

      {showPopup && (
        <div className="popup-overlay" onClick={handleClose}>
          <div className="popup-container" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClose}>
              &times;
            </button>
            
            <div className="popup-content">
              <h2>Need help with Route Planner?</h2>
              
              <p className="popup-message">
                Submit your issue or question below and our support team will assist you.{' '}
                <a 
                  href={process.env.REACT_APP_SUPPORT_FORM_URL || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-link"
                  onClick={(e) => {
                    if (!process.env.REACT_APP_SUPPORT_FORM_URL) {
                      e.preventDefault();
                      alert('Please configure REACT_APP_SUPPORT_FORM_URL in your .env file');
                    } else {
                      setShowPopup(false);
                    }
                  }}
                >
                  Click here
                </a>
                {' '}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;